export const defaultConfig = {
  // baseAPIUrl:"http://192.168.0.156:3006/api/",
  // imageUrl:"http://192.168.0.156:3006/images/",

  //Bt Server
  baseAPIUrl:"https://credoapp.etrueconcept.com/api/",
  imageUrl:"https://credoapp.etrueconcept.com/images/",

 applestore:"https://apps.apple.com/in/app/credo-in-deum/id6754548985",
  playstore:"https://apps.apple.com/in/app/credo-in-deum/id6754548985",

  //Client Server
  // baseAPIUrl:"https://credoindeumapp.com/api/",
  // imageUrl:"https://credoindeumapp.com/images/",
  
};
